/**
 * "Export PNG" toolbar button: forces a render of the current globe state and
 * downloads the canvas as a transparent PNG. Extracted verbatim from the globe
 * client monolith (Phase 3). Self-contained; talks to the globe through the
 * window.globe seam.
 */
/* eslint-disable */
export function initExportPng(): void {
    var exportPngBtn = document.getElementById('export-png-btn');
    if (exportPngBtn) {
      exportPngBtn.addEventListener('click', function() {
        if (!window.globe || !window.globe.renderer) {
          console.warn('Globe not ready for export');
          return;
        }

        var renderer = window.globe.renderer;
        var canvas = renderer.domElement;

        // Force a render to ensure latest state
        window.globe.needsRender = true;
        renderer.render(window.globe.scene, window.globe.camera);

        // Get the canvas data as PNG with transparency
        var dataUrl = canvas.toDataURL('image/png');

        // Create download link
        var link = document.createElement('a');
        link.download = 'globe-export.png';
        link.href = dataUrl;
        link.click();
      });
    }
}
